import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Transition } from "@headlessui/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { IoAlertCircle } from "@superwall/icons/io5/IoAlertCircle";
import { IoCheckmarkCircle } from "@superwall/icons/io5/IoCheckmarkCircle";
import { toast as toastBase } from "react-toastify";
const ToolTip = ({ toolTip, orientationInstruction })=>{
    const dynamicToolTipCss = useMemo(()=>{
        return setStyleType(orientationInstruction);
    }, [
        orientationInstruction
    ]);
    switch(toolTip.state){
        case 3:
            {
                return toolTip.value;
            }
        case 0:
        case 2:
        case 1:
            {
                const width = toolTip.width;
                const height = toolTip.height;
                return /*#__PURE__*/ _jsx("div", {
                    className: `absolute z-[100] mb-2 px-[8px] py-[4px] flex rounded-md shadow-elevation-max ${toolTip.state === 1 || toolTip.state === 2 ? toolTip.state === 1 ? "text-alert-primary" : "text-warn-primary" : ""}`,
                    style: {
                        ...width ? {
                            width
                        } : {
                            whiteSpace: "nowrap"
                        },
                        height,
                        ...toolTip.state === 1 ? {
                            backgroundColor: "#282D36",
                            border: "1px solid rgba(255,255,255,0.1)",
                            cursor: "cursor-default !important"
                        } : {
                            backgroundColor: "#282D36",
                            border: "1px solid rgba(255,255,255,0.1)",
                            cursor: "cursor-default !important"
                        },
                        ...toolTip.state === 2 ? {
                            backgroundColor: "#282D36",
                            border: "1px solid white",
                            cursor: "cursor-default !important"
                        } : {},
                        ...dynamicToolTipCss
                    },
                    children: toolTip.value
                });
            }
    }
};
export var ToolTipHangDirection = /*#__PURE__*/ function(ToolTipHangDirection) {
    ToolTipHangDirection[ToolTipHangDirection["Above"] = 0] = "Above";
    ToolTipHangDirection[ToolTipHangDirection["Below"] = 1] = "Below";
    ToolTipHangDirection[ToolTipHangDirection["Left"] = 2] = "Left";
    ToolTipHangDirection[ToolTipHangDirection["Right"] = 3] = "Right";
    ToolTipHangDirection[ToolTipHangDirection["AboveStart"] = 4] = "AboveStart";
    ToolTipHangDirection[ToolTipHangDirection["BelowStart"] = 5] = "BelowStart";
    ToolTipHangDirection[ToolTipHangDirection["LeftStart"] = 6] = "LeftStart";
    ToolTipHangDirection[ToolTipHangDirection["RightStart"] = 7] = "RightStart";
    ToolTipHangDirection[ToolTipHangDirection["AboveEnd"] = 8] = "AboveEnd";
    ToolTipHangDirection[ToolTipHangDirection["BelowEnd"] = 9] = "BelowEnd";
    ToolTipHangDirection[ToolTipHangDirection["LeftEnd"] = 10] = "LeftEnd";
    ToolTipHangDirection[ToolTipHangDirection["RightEnd"] = 11] = "RightEnd";
    ToolTipHangDirection[ToolTipHangDirection["Center"] = 12] = "Center";
    return ToolTipHangDirection;
}({});
const setStyleType = (hangInstruction)=>{
    switch(hangInstruction.direction){
        case 3:
            {
                return {
                    left: `calc(100% + 5px)`,
                    transform: `translateY(-50%)`,
                    textAlign: "center"
                };
            }
        case 2:
            {
                return {
                    top: `${hangInstruction.targetHeight / 2}px`,
                    textAlign: "center",
                    transform: `translateY(-50%)`,
                    right: `${hangInstruction.targetWidth}px`
                };
            }
        case 0:
            {
                return {
                    left: `50%`,
                    textAlign: "left",
                    top: `-5px`,
                    transform: `translate(-50%, -100%)`
                };
            }
        case 1:
            {
                return {
                    left: `${hangInstruction.targetWidth / 2}px`,
                    textAlign: "center",
                    transform: `translateX(-50%)`,
                    top: `${hangInstruction.targetHeight}px`
                };
            }
        case 11:
            {
                return {
                    bottom: `0px`,
                    textAlign: "right",
                    left: `${hangInstruction.targetWidth}px`
                };
            }
        case 10:
            {
                return {
                    bottom: `0px`,
                    textAlign: "right",
                    right: `${hangInstruction.targetWidth}px`
                };
            }
        case 8:
            {
                return {
                    right: `0%`,
                    textAlign: "left",
                    top: `-5px`,
                    transform: `translate(0, -100%)`
                };
            }
        case 9:
            {
                return {
                    right: `0px`,
                    textAlign: "right",
                    top: `${hangInstruction.targetHeight + 5}px`
                };
            }
        case 7:
            {
                return {
                    top: `0px`,
                    textAlign: "left",
                    left: `${hangInstruction.targetWidth}px`
                };
            }
        case 6:
            {
                return {
                    top: `0px`,
                    textAlign: "left",
                    right: `${hangInstruction.targetWidth}px`
                };
            }
        case 4:
            {
                return {
                    left: `0%`,
                    textAlign: "left",
                    top: `-5px`,
                    transform: `translate(0%, -100%)`
                };
            }
        case 5:
            {
                return {
                    top: `${hangInstruction.targetHeight + 5}px`,
                    textAlign: "left",
                    left: `0px`
                };
            }
        case 12:
            {
                return {
                    left: `50%`,
                    textAlign: "center",
                    top: `50%`,
                    transform: `translate(-50%, -50%)`
                };
            }
    }
};
export var ToolTipType = /*#__PURE__*/ function(ToolTipType) {
    ToolTipType[ToolTipType["Standard"] = 0] = "Standard";
    ToolTipType[ToolTipType["Alert"] = 1] = "Alert";
    ToolTipType[ToolTipType["Warn"] = 2] = "Warn";
    ToolTipType[ToolTipType["Headless"] = 3] = "Headless";
    return ToolTipType;
}({});
export var DisplayBehavior = /*#__PURE__*/ function(DisplayBehavior) {
    DisplayBehavior[DisplayBehavior["Hover"] = 0] = "Hover";
    DisplayBehavior[DisplayBehavior["Timer"] = 1] = "Timer";
    return DisplayBehavior;
}({});
export const ToolTipWrapper = ({ disabled, toolTip, direction = 8, displayBehavior = 1, children, ...outerProps })=>{
    const toolTipWrapper = useRef(null);
    const [mounted, setMounted] = useState(false);
    const [_showing, setShowing] = useState(displayBehavior === 1);
    let displayTimer = useRef(undefined);
    // Only actually show it if it's not disabled
    const showing = _showing && !disabled;
    useEffect(()=>{
        setMounted(true);
    }, []);
    useEffect(()=>{
        if (displayBehavior === 1) {
            // @ts-ignore
            displayTimer.current = setTimeout(()=>{
                setShowing(false);
            }, 3000);
        } else {}
    }, [
        setShowing,
        displayBehavior
    ]);
    let hangInstruction = useMemo(()=>{
        if (mounted && toolTipWrapper.current && toolTipWrapper.current.clientHeight && toolTipWrapper.current.clientWidth) {
            return {
                direction: direction,
                targetHeight: toolTipWrapper.current.clientHeight,
                targetWidth: toolTipWrapper.current.clientWidth
            };
        } else {
            return undefined;
        }
    }, [
        toolTipWrapper,
        direction,
        mounted
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ref: toolTipWrapper,
        onMouseEnter: ()=>{
            // @ts-ignore
            displayTimer.current = setTimeout(()=>{
                setShowing(true);
            }, 350);
        },
        onMouseLeave: ()=>{
            if (displayTimer.current) clearTimeout(displayTimer.current);
            setShowing(false);
        },
        ...outerProps,
        children: [
            children,
            hangInstruction && showing ? /*#__PURE__*/ _jsx(Transition, {
                show: showing,
                enter: "transition ease-out duration-100",
                enterFrom: "transform opacity-0 scale-95",
                enterTo: "transform opacity-100 scale-100",
                leave: "transition ease-in duration-75",
                leaveFrom: "transform opacity-100 scale-100",
                leaveTo: "transform opacity-0 scale-95",
                children: /*#__PURE__*/ _jsx(ToolTip, {
                    orientationInstruction: hangInstruction,
                    toolTip: toolTip
                })
            }) : undefined
        ]
    });
};
const defaultToastOptions = {
    theme: "dark",
    position: "top-right",
    autoClose: 3000,
    closeButton: true,
    hideProgressBar: true,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    draggable: true,
    draggablePercent: 40,
    draggableDirection: "x"
};
export const toast = {
    loading: (content)=>{
        return toastBase.loading(content, defaultToastOptions);
    },
    success: ({ content, options, toastId })=>{
        if (toastId) {
            toastBase.update(toastId, {
                render: content,
                type: toastBase.TYPE.SUCCESS,
                isLoading: false,
                icon: /*#__PURE__*/ _jsx(IoCheckmarkCircle, {
                    className: ` w-10 text-accent-light`
                }),
                ...defaultToastOptions
            });
            return toastId;
        } else {
            return toastBase.success(content, {
                icon: /*#__PURE__*/ _jsx(IoCheckmarkCircle, {
                    className: ` w-10 text-accent-light`
                }),
                ...defaultToastOptions
            });
        }
    },
    error: ({ content, options, toastId })=>{
        if (toastId) {
            toastBase.update(toastId, {
                render: content,
                type: toastBase.TYPE.ERROR,
                isLoading: false,
                icon: /*#__PURE__*/ _jsx(IoAlertCircle, {
                    className: `w-10 text-alert-primary`
                }),
                ...defaultToastOptions
            });
            return toastId;
        } else {
            return toastBase.error(content, {
                icon: /*#__PURE__*/ _jsx(IoAlertCircle, {
                    className: `w-10 text-alert-primary`
                }),
                ...defaultToastOptions
            });
        }
    },
    dismiss: (toastId)=>{
        toastBase.dismiss(toastId);
    }
};
